import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ActivationEnd, NavigationEnd, Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.less']
})

export class AuthComponent implements OnInit, OnDestroy {

  public environment = environment;
  year: number = new Date().getFullYear();
  url = '';
  authPageTitle = 'Login';

  // 'textLinkToShow' : [array for urls when to show the link]
  mapLoginFormLinks = {
    'forgotPassword': ['/auth/login'],
    'resendEmail': ['/auth/password/request', '/auth/login', '/auth/email/verify'],
    'login': ['/auth/password/request', '/auth/email/resend']
  };

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.activatedRoute.url.subscribe(() => {
      this.url = window.location.pathname;
      this.authPageTitle = this.activatedRoute.snapshot.firstChild.data.title;
    });

    this.router.events.subscribe((event: any) => {
      if (event instanceof ActivationEnd && event.snapshot.data.title) {
        this.authPageTitle = event.snapshot.data.title;
      }
      if (event instanceof NavigationEnd && event.url) {
        this.url = event.url;
      }
    });
  }


  isShowLinkInForm(linkToCheckShow: string) {
    const isShowLink = this.mapLoginFormLinks[linkToCheckShow].some(link => this.url.includes(link));
    return isShowLink;
  }

  ngOnDestroy() {
    document.querySelector('body').removeAttribute('id');
  }
}
